import { api } from '@/lib/api';

interface UploadResponse {
  key: string;
  url: string | null;
  contentType: string;
  size: number;
}

type UploadPurpose = 'platform_content_default' | 'support_ticket_file';

export const uploadBlob = async (input: {
  purpose: UploadPurpose;
  blob: Blob;
  fileName?: string;
  /** Required for church-scoped purposes such as support ticket files. */
  churchId?: string;
}): Promise<{ key: string; url: string | null; contentType: string }> => {
  const form = new FormData();
  form.append('file', input.blob, input.fileName ?? `upload${extensionFor(input.blob.type)}`);
  form.append('purpose', input.purpose);

  const result = await api.postForm<UploadResponse>('/storage/upload', form, {
    churchId: input.churchId,
  });
  return { key: result.key, url: result.url, contentType: result.contentType };
};

const extensionFor = (contentType: string): string => {
  switch (contentType) {
    case 'image/jpeg':
      return '.jpg';
    case 'image/png':
      return '.png';
    case 'image/webp':
      return '.webp';
    case 'application/pdf':
      return '.pdf';
    default:
      return '';
  }
};
